import React from 'react';
import { Menu, Typography, Box, Divider, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import NotificationListItem from './NotificationListItem';

const StyledMenu = styled(Menu)(() => ({
  '& .MuiPaper-root': {
    borderRadius: 12,
    width: 380,
    maxWidth: 'calc(100vw - 24px)',
    boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.14)',
    '& .MuiMenu-list': {
      padding: 0,
    },
  },
}));

/**
 * Menu do sino: avisos abertos do usuário (vindos de useNotifications, já em memória;
 * abrir o menu não faz chamada). Clicar num aviso marca como lido e abre o link dele
 * (sem link, a página de notificações).
 */
function NotificationsMenu({ anchorEl, open, onClose, items, unreadCount, loaded, onMarkRead, onMarkAllRead }) {
  const navigate = useNavigate();

  const handleItemClick = (item) => {
    if (!item.is_read) onMarkRead([item.id]);
    onClose();
    // aviso sem link próprio abre a página de notificações, onde o texto aparece inteiro
    navigate(item.link || '/notifications');
  };

  const handleSeeAll = () => {
    onClose();
    navigate('/notifications');
  };

  return (
    <StyledMenu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2, py: 1.25 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, color: 'var(--color-text-dark)' }}>
          Notificações
        </Typography>
        {unreadCount > 0 && (
          <Button size="small" onClick={onMarkAllRead} startIcon={<DoneAllIcon fontSize="small" />} sx={{ textTransform: 'none' }}>
            Marcar todas como lidas
          </Button>
        )}
      </Box>

      <Divider />

      <Box sx={{ maxHeight: 420, overflowY: 'auto' }}>
        {items.length === 0 ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4, px: 2, color: 'var(--color-text-light)' }}>
            <NotificationsNoneOutlinedIcon sx={{ fontSize: 44, opacity: 0.5, mb: 1 }} />
            <Typography variant="body2">
              {loaded ? 'Tudo em dia por aqui.' : 'Carregando...'}
            </Typography>
          </Box>
        ) : (
          items.map((item) => (
            <NotificationListItem key={item.id} item={item} dense onClick={() => handleItemClick(item)} />
          ))
        )}
      </Box>

      <Divider />

      <Box sx={{ p: 1 }}>
        <Button fullWidth onClick={handleSeeAll} sx={{ textTransform: 'none' }}>
          Ver todas as notificações
        </Button>
      </Box>
    </StyledMenu>
  );
}

export default NotificationsMenu;
